/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Returns the dragMode during initial render or when dragMode props
 * change (i.e when user hasn't selected yet) based on available dragModes.
 */
export function getInitialDragMode(
  dragMode: 'pan' | 'user' | 'zoom' | 'select' | 'off' | undefined,
  showPanButton: boolean,
  showZoomButton: boolean,
  showSelectButton: boolean
) {
  return showPanButton && (dragMode === 'pan' || dragMode === 'user')
    ? 'pan'
    : showZoomButton && dragMode === 'zoom'
    ? 'zoom'
    : showSelectButton && dragMode === 'select'
    ? 'select'
    : undefined;
}
